export default {"src":"/_next/static/media/bb-coffee.1f71603a.svg","height":1145,"width":844,"blurWidth":0,"blurHeight":0};